import React, {
  createContext,
  PropsWithChildren,
  useMemo,
} from 'react';
import noop from 'lodash/noop';
import useSpeechToText, {
  SpeechPhraseList,
  VoiceRecognitionData,
} from 'pages/Dashboard/hooks/useSpeechToText';

export const SpeechRecognitionContext = createContext<VoiceRecognitionData>({
  listening: false,
  loading: false,
  text: '',
  startVoiceRecognition: noop,
  stopVoiceRecognition: noop,
  unprocessedText: '',
});

type Props = PropsWithChildren & {
  trackingLabel?: string;
  phraseList?: SpeechPhraseList;
};

export default function SpeechRecognitionProvider({
  children,
  trackingLabel,
  phraseList,
}: Props) {
  const data = useSpeechToText({
    trackingLabel,
    phraseList,
  });
  const value = useMemo(() => data, [data]);

  return (
    <SpeechRecognitionContext.Provider value={value}>
      {children}
    </SpeechRecognitionContext.Provider>
  );
}
